import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import outputs from './amplify_outputs.json'; 

// 1. Load the default AWS styles FIRST
import '@aws-amplify/ui-react/styles.css'; 

// 2. Load your custom Masta Homes styles SECOND so they override AWS!
import './App.css'; 

import App from './App';

const amplifyConfig = {
  ...outputs,
  AWS_PROJECT_REGION: outputs.auth?.aws_region || 'ap-southeast-2',
};

Amplify.configure(amplifyConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);